<!--
NearMe screen to show features close by.
@author ab557z, bmk11u, crm4f
-->
<template>
  <div id="contain" class="container">
 <!-- <div class="btn-group w-100">
      <router-link v-if="authenticated" to="/" class="btn btn-primary nav-button">Home</router-link>
    </div> -->
        <div id="nearMeDropdown" class="nearMeDropDiv" v-show="showFeaturesDiv">
          <table id="table" style="table-layout: fixed; height:324px; border-collapse: separate; border-spacing:5px;">
            <tr v-bind:key="index" v-for="row, index in totalRows">
              <td v-bind:key="index" v-for="col, index in ((row == totalRows) ? (ftrs.length % 3 === 0 ? 3 : ftrs.length % 3) : 3)" :class="{'featurePressed' : getCurrentItem(row, col).pressed}"
             v-on:click="getCurrentItem(row, col).pressed  = !getCurrentItem(row, col).pressed; getCurrentItem(row, col).show = !getCurrentItem(row, col).show; showFeaturesDiv = !showFeaturesDiv; reloadData();">
                <font-awesome-icon v-if="getCurrentItem(row, col).faIcon" class="footerImg" :icon="getCurrentItem(row, col).icon" size="lg"></font-awesome-icon>
                <img v-else :id="getCurrentItem(row, col).name" :src="getCurrentItem(row, col).icon" />
                <br>
                {{ getCurrentItem(row, col).display }}
              </td>
            </tr>
          </table>
        </div>
    <Nav name="Near Me" :step="authenticated==='true'" :back="authenticated===true" :showNotif="authenticated===true"/>
    <GMapMap
      :center='{lat:55.872446, lng:-4.289041}'
      :zoom='17'
      class='mapCanvas tallMap'
      id="nearMe"
      ref='mapRef'
      style="width: 100%; height: 80vh;"
      :options='{
        styles: getStyles(),
        fullscreenControl: false,
        mapTypeControl: false,
        mapTypeControlOptions: {
          position: google && google.maps.ControlPosition.TOP_LEFT,
          style: google && google.maps.MapTypeControlStyle.DROPDOWN_MENU
        },
        streetViewControl: true,
        zoomControl: true
      }'>
    </GMapMap>

   <div id="embeddedMapControls" style="width:100%;" class="btn-group">

     <button id="featureBtn" class="btn btn-ml"  @click="showFeaturesDiv = !showFeaturesDiv;" href="#/nearme" style="box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
border-radius: 12px;width:auto;margin-top:24px;margin-left:24px;height:52px;margin-right:24px;padding-top:12px;padding-left:16px;background-color:#003865;color:#ffffff;" title="Select Features">
       <p style="font-weight:700;font-size:18px;">Select Features</p>
     </button>

    </div>

    <Footer active="nearme" v-if="authenticated"/>
    <NewConfirm ref="confirmRef" />
  </div>
</template>

<script setup>
import $ from 'jquery'
import { useLocationsCommon } from '@/composables/LocationsCommon.js'
import { useGeoCommon } from '@/composables/GeoCommon.js'
import { useMapCommon } from '@/composables/MapCommon.js' 
import axios from 'axios'
import Footer from '@/components/FooterMenu.vue'
import { onMounted, ref, watch } from 'vue'

const google = ref(null) /* to hold gmap api from promise */
const mapRef = ref(null)
const map = ref(null)
const confirmRef = ref(null)
const isOfferHoldersDay = ref(false)
const exRelName = ref('')
const showFeaturesDiv = ref(false)
const locationMarker = ref(null)
const locationInitialised = ref(false)
const ftrs = ref([
  { name: 'AccessibleParking', display: 'Accessible Parking', show: false, pressed: false, icon: 'car', faIcon: true },
  { name: 'AccessibleToilets', display: 'Accessible Toilets', show: false, pressed: false, icon: 'wheelchair', faIcon: true },
  { name: 'Atms', display: 'ATMs', show: false, pressed: false, icon: 'pound-sign', faIcon: true },
  { name: 'BabyChanging', display: 'Baby Changing', show: false, pressed: false, icon: 'baby', faIcon: true },
  { name: 'BikeRacks', display: 'Bike Racks', show: false, pressed: false, icon: 'bicycle', faIcon: true },
  { name: 'Defibrillators', display: 'Defibrillators', show: false, pressed: false, icon: require('@/assets/defibrillatorLG.svg'), faIcon: false },
  { name: 'FoodOutlets', display: 'Food Outlets', show: false, pressed: false, icon: 'coffee', faIcon: true },
  { name: 'PeriodProducts', display: 'Period Products', show: false, pressed: false, icon: require('@/assets/period-productLG.svg'), faIcon: false },
  { name: 'PrayerAndReflection', display: 'Prayer And Reflection', show: false, pressed: false, icon: require('@/assets/PrayerAndReflectionLG.svg'), falcon: false },
  { name: 'RetailOutlets', display: 'Retail Outlets', show: false, pressed: false, icon: require('@/assets/retail-outletLG.svg'), falcon: false },
  { name: 'Showers', display: 'Showers', show: false, pressed: false, icon: 'shower', faIcon: true },
  { name: 'Toilets', display: 'Toilets', show: false, pressed: false, icon: 'restroom', faIcon: true },
  { name: 'Attractions', display: 'Attractions', show: false, pressed: false, icon: 'camera', faIcon: true },
  { name: 'WaterFountains', display: 'Water Fountains', show: false, pressed: false, icon: 'tint', faIcon: true }
])
const totalRows = ref(0)
const { authenticated } = useLocationsCommon()
const { geoLatitude, geoLongitude, geoLocationAvailable  } = useGeoCommon()

const { 
  clearFeatures, 
  getBuildingGroupStyle, 
  initFeatures, 
  addMarker, 
  getStyles, 
  getBuildingStyle, 
  initGeoJson, 
  } = useMapCommon()

onMounted(() => {
  totalRows.value = Math.ceil(ftrs.value.length / 3)
  resizeMap()

  window.addEventListener('resize', resizeMap, false)

  axios.get('/timetable/public/externalrelations/value')
    .then(response => {
      axios.get('/timetable/public/externalrelations/name')
        .then(response2 => {
          isOfferHoldersDay.value = (response.data === 'Y')
          exRelName.value = response2.data
        })
    })

  if (isOfferHoldersDay.value) {
    ftrs.value.unshift(
      { name: 'OfferHoldersDay', display: 'Offer Holders Day', show: false, pressed: false, icon: 'info-circle', faIcon: true }
    )
  }

  // we need to get gmapApi...
  mapRef.value.$gmapApiPromiseLazy().then((gmapApi) => {
    console.log('gmapApi promise fulfilled')
    google.value = gmapApi
  }).then(() => {
    mapRef.value.$mapPromise.then((mapResponse) => {
    // Wait for Google Maps to load
      map.value = mapResponse
      initGeoJson(mapResponse, setMapDataStyle)
      setLocation()
      var embeddedMapControls = $('#embeddedMapControls')
      if (embeddedMapControls.get(0) != null) {
        map.value.controls[google.value.maps.ControlPosition.TOP_CENTER].push(embeddedMapControls.get(0))
        $('#embeddedMapControls').removeClass('hidden')
      }
    })
  })

  // stop dropdown closing
  $('#nearmeDropdown').click(function (e) {
    if (e.target.id == 'closeBtn') {
      $('.dropdown-menu').toggle()
    } else {
      e.stopPropagation()
    }
  })
})

// Watch for changes to geo location
watch(geoLatitude, () => {
  setLocation()
})

watch(geoLongitude, () => {
  setLocation()
})

function resizeMap () {
  var windowHeight = $(window).innerHeight()
  var mapHeight = windowHeight - 58 - 47
  $('#nearMe').height(mapHeight)
  var windowWidth = $('#app').innerWidth()
  $('#activeFeatures').width(windowWidth)
}

// Overrides MapCommon.loadGeoJson. This is called by MapCommon.initGeoJson and reloadData above.
// Loads building overlay geo json data and (optionally) map features.
function overrideLoadGeoJson (map) {
  clearFeatures(map)
  let request = getRequest()
  // Import FeatureLabal, wait the render over buildings
  import('@/components/FeatureLabel.js')
    .then(FeatureLabel => {
      map.data.loadGeoJson(process.env.VUE_APP_WS_URL + request,
        {}, (features) => {
          initFeatures(map, FeatureLabel, features)
        })
    })
}

function getRequest () {
  let request = '/map/features?showBuildings=true&showAccessibleRoutes=false'
  for (let i = 0; i < ftrs.value.length; i++) {
    request += '&show' + ftrs.value[i].name + '=' + ftrs.value[i].show
  }
  return request
}

function setMapDataStyle (map) {
  map.data.setStyle((feature) => {
    let featureType = feature.getProperty('featureType')
    if (featureType === 'Building') {
      return getBuildingStyle(map, feature)
    } else if (featureType === 'BuildingGroup') {
      return getBuildingGroupStyle()
    } else {
      return {
        title: feature.getProperty('featureName'),
        icon: require('../assets/nearme/' + featureType.toLowerCase() + '.png')
      }
    }
  })
}

function getCurrentItem (row, col) {
  return ftrs.value[((row - 1) * 3) + col - 1]
}

function reloadData () {
  overrideLoadGeoJson(map.value)
}

// Initialises the default map location or moves the current location marker, if present, on subsequent requests.
// Called on map load or geo location change.
function setLocation () {
  // Wait for map and geo location to load
  if (map.value != null && geoLocationAvailable) {
    if (locationInitialised.value) {
      if (isOnCampus(geoLatitude, geoLongitude)) {
        console.log('is on campus')
        showLocation()
      } else {
        confirmRef.value.show('It looks like you are off-campus at the moment.\nClick OK to show your current location or Cancel for the campus map.',
          () => {
            showLocation()
          })
      }
      locationInitialised.value = true
    } else {
      if (locationMarker.value != null) {
        console.log('move marker')
        locationMarker.value.setPosition(new google.value.maps.LatLng(geoLatitude, geoLongitude))
      }
    }
  }
}

// Adds a location marker for the current geo location and pans to it.
function showLocation () {
  locationMarker.value = addMarker(map.value, google.value, 'Your current location', geoLatitude, geoLongitude, null, null, false, require('../assets/location.png'))
  map.value.panTo({ lat: geoLatitude, lng: geoLongitude })
}
</script>

<style scoped>

.gm-ui-hover-effect {
  box-shadow: none !important;
  background-color: transparent !important;
  border: none !important;
}

.scrollFeatures {
  overflow-x:scroll;
  overflow-y:hidden;
}

#activeFeatures {
  position:absolute;
  z-index:2;
  top:160px;
  height:60px;
}

#nearMeDropdown {
  width:330px;
  padding-top:5px;
  margin-top:21px;
  padding-bottom:7px;
  padding-left:2px;
  padding-right:3px;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  text-align:center;
  position:absolute;
  top:130px;
  z-index:9999;
  background-color:#ffffff;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 16px;
  line-height: 1.4;
}

#Defibrillators, #PeriodProducts, #RetailOutlets {
  height:20px;
  margin-top:-16px;
  margin-bottom:-8px;
  padding-bottom:-14px;
}

#PrayerAndReflection {
  height:42px;
  margin-top:-16px;
  margin-bottom:-8px;
  padding-bottom:-14px;
}

.featurePressed {
  background-color:#E8ECF2;
}

#nearMeDropdown td {
  padding-top:18px;
  padding-bottom:0px;
  padding-left:5px;
  margin-left:3px;
  margin-right:2px;
  padding-right:5px;
  border-radius:16px;
  color:#003865;
  font-weight:700;
}

@media screen and (max-height: 568px) {
#nearMeDropdown {
  overflow:auto;
  max-height:370px;
}
}

</style>
